if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        
        if (!this.form) {
          return;
        }
        
        this.variantIdInput.disabled = false;
        // Only add event listener if no addons are selected
        this.form.addEventListener('submit', (e) => {
          // Check if addon drawer is active and has selected addons
          if (window.addonDrawerInstance && this.hasSelectedAddons()) {
            // Let addon drawer handle the submission
            return;
          }
          // No addons selected, use default handler
          this.onSubmitHandler(e);
        });
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        // Enforce ring size selection if selector exists on the page
        this.ringSizeSelect = document.getElementById('select-ring-size');
        if (this.ringSizeSelect) {
          this.initRingSizeRequirement();
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        // Check if button is disabled due to ring size
        if (this.submitButton.classList.contains('ring-size-disabled') || this.submitButton.getAttribute('aria-disabled') === 'true') {
          if (this.ringSizeSelect && !this.isRingSizeValid()) {
            this.alertRingSizeRequired();
            return;
          }
        }

        // Prevent submission if ring size is required but not selected
        if (this.ringSizeSelect && !this.isRingSizeValid()) {
          this.alertRingSizeRequired();
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Add unique identifiers to prevent quantity merging
        const uniqueId = Date.now().toString() + Math.random().toString(36).substr(2, 9);
        const sessionId = this.getSessionId();
        const cartTimestamp = Date.now().toString();
        
        // Add unique properties to form data
        formData.append('properties[_unique_id]', uniqueId);
        formData.append('properties[_session_id]', sessionId);
        formData.append('properties[_cart_timestamp]', cartTimestamp);
        formData.append('properties[_is_standalone_product]', 'true');
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            
            // Reset ring size selector after successful add to cart
            setTimeout(() => {
              this.resetRingSizeSelector();
            }, 100);
            
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            // Handle error silently
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          // Don't actually disable to allow click events
          // Instead use CSS class and aria-disabled for styling
          this.submitButton.classList.add('ring-size-disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          // if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.classList.remove('ring-size-disabled');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.removeAttribute('disabled');
          // this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      // Check if a valid ring size is selected
      isRingSizeValid() {
        if (!this.ringSizeSelect) return true;
        const value = this.ringSizeSelect.value;
        return value !== undefined && value !== null && String(value).trim() !== '';
      }

      // Initialize enforcement: disable submit until ring size is selected
      initRingSizeRequirement() {
        // Initial state
        if (!this.isRingSizeValid()) {
          this.toggleSubmitButton(true, 'Select Ring Size');
        }

        // Update button on change
        this.ringSizeSelect.addEventListener('change', () => {
          if (this.isRingSizeValid()) {
            this.toggleSubmitButton(false);
            this.handleErrorMessage(false);
            this.removeRingSizeAlert();
          } else {
            this.toggleSubmitButton(true, 'Select Ring Size');
          }
        });

        // Handle click on disabled button (check before form submit)
        this.submitButton.addEventListener('click', (e) => {
          if (this.submitButton.classList.contains('ring-size-disabled') || this.submitButton.getAttribute('aria-disabled') === 'true') {
            if (!this.isRingSizeValid()) {
              e.preventDefault();
              e.stopPropagation();
              this.alertRingSizeRequired();
              return false;
            }
          }
        });
      }

      // Alert user to select ring size: scroll, highlight, and show message
      alertRingSizeRequired() {
        if (!this.ringSizeSelect) return;

        // Find the container for message placement
        const ringSizeContainer = this.ringSizeSelect.closest('.cstm-line-itemoption.cli-size') || 
                                   this.ringSizeSelect.closest('.ring-size-guide') ||
                                   this.ringSizeSelect.parentElement;

        // Scroll to ring size selector
        try {
          const scrollTarget = ringSizeContainer || this.ringSizeSelect;
          const offsetTop = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        } catch (e) {
          // Fallback scroll
          this.ringSizeSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        // Highlight border of the select element itself
        if (this.ringSizeSelect) {
          const originalBorder = this.ringSizeSelect.style.border;
          const originalBoxShadow = this.ringSizeSelect.style.boxShadow;
          const originalOutline = this.ringSizeSelect.style.outline;
          
          this.ringSizeSelect.style.transition = 'border-color 0.3s ease, box-shadow 0.3s ease, outline 0.3s ease';
          this.ringSizeSelect.style.border = '2px solid #ef4444';
          this.ringSizeSelect.style.borderRadius = '4px';
          this.ringSizeSelect.style.boxShadow = '0 0 0 3px rgba(239, 68, 68, 0.1)';
          this.ringSizeSelect.style.outline = 'none';
          
          // Remove highlight after 3 seconds
          setTimeout(() => {
            if (this.ringSizeSelect) {
              this.ringSizeSelect.style.border = originalBorder;
              this.ringSizeSelect.style.boxShadow = originalBoxShadow;
              this.ringSizeSelect.style.outline = originalOutline;
            }
          }, 3000);
        }

        // Show message
        this.showRingSizeAlertMessage();
      }

      // Show alert message near ring size selector
      showRingSizeAlertMessage() {
        // Remove existing message if any
        this.removeRingSizeAlert();

        const ringSizeContainer = this.ringSizeSelect.closest('.cstm-line-itemoption.cli-size') || 
                                   this.ringSizeSelect.closest('.ring-size-guide') ||
                                   this.ringSizeSelect.parentElement;

        if (!ringSizeContainer) return;

        const alertMsg = document.createElement('div');
        alertMsg.className = 'ring-size-alert-message';
        alertMsg.textContent = 'Please select a ring size to add to cart';
        alertMsg.style.cssText = `
          color: #ef4444;
          font-size: 14px;
          font-weight: 500;
          margin-top: 8px;
          padding: 8px 12px;
          background-color: #fef2f2;
          border: 1px solid #fecaca;
          border-radius: 4px;
          animation: fadeIn 0.3s ease;
        `;

        // Add fade-in animation if not exists
        if (!document.getElementById('ring-size-alert-styles')) {
          const style = document.createElement('style');
          style.id = 'ring-size-alert-styles';
          style.textContent = `
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(-10px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `;
          document.head.appendChild(style);
        }

        ringSizeContainer.appendChild(alertMsg);

        // Auto remove after 5 seconds
        setTimeout(() => {
          this.removeRingSizeAlert();
        }, 5000);
      }

      // Remove alert message
      removeRingSizeAlert() {
        const existingAlert = document.querySelector('.ring-size-alert-message');
        if (existingAlert) {
          existingAlert.style.opacity = '0';
          existingAlert.style.transform = 'translateY(-10px)';
          setTimeout(() => {
            if (existingAlert.parentNode) {
              existingAlert.parentNode.removeChild(existingAlert);
            }
          }, 300);
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
      
      hasSelectedAddons() {
        // Check if addon drawer instance exists and has selected addons
        if (!window.addonDrawerInstance) {
          return false;
        }
        
        try {
          // Get current product ID
          const productId = window.addonDrawerInstance.getCurrentProductId();
          if (!productId) {
            return false;
          }
          
          // Check if there are saved addons for this product
          const savedAddons = window.addonDrawerInstance.getAddonsForProduct(productId);
          return savedAddons && savedAddons.length > 0;
        } catch (error) {
          // If there's any error, assume no addons
          return false;
        }
      }
      
      getSessionId() {
        // Get or create session ID
        let sessionId = sessionStorage.getItem('cart_session_id');
        if (!sessionId) {
          sessionId = 'session_' + Date.now().toString() + '_' + Math.random().toString(36).substr(2, 9);
          sessionStorage.setItem('cart_session_id', sessionId);
        }
        return sessionId;
      }
      
      resetRingSizeSelector() {
        
        try {
          // Reset the select element
          const ringSizeSelect = document.getElementById('select-ring-size');
          if (ringSizeSelect) {
            ringSizeSelect.value = '';
            ringSizeSelect.selectedIndex = 0;
            
            // Update the selected value display
            const selectedValueSpan = ringSizeSelect.closest('.cstm-line-itemoption')?.querySelector('.selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = 'Select Ring Size';
            }
            
            // Reset the ring size dropdown UI
            const ringSizeDropdown = ringSizeSelect.closest('.ring-size-dropdown');
            if (ringSizeDropdown) {
              const ringSizeButton = ringSizeDropdown.querySelector('.ring-size-button');
              const caretIcon = ringSizeDropdown.querySelector('.caret-icon');
              const options = ringSizeDropdown.querySelector('.ring-size-options');
              
              if (ringSizeButton) {
                ringSizeButton.setAttribute('aria-expanded', 'false');
                ringSizeButton.textContent = 'Select Ring Size';
              }
              
              if (caretIcon) {
                caretIcon.style.transform = 'rotate(0deg)';
              }
              
              if (options) {
                options.classList.add('hidden');
              }
            }
            
            // Trigger change event to update UI
            ringSizeSelect.dispatchEvent(new Event('change', { bubbles: true }));

            // Ensure submit is disabled again until user selects a size
            if (this.ringSizeSelect) {
              this.toggleSubmitButton(true, 'Select Ring Size');
            }
          }
        } catch (error) {
          // Handle error silently
        }
      }
      
      // Test function to check unique ID generation
      static testUniqueIdGeneration() {
        // Create a temporary product form instance for testing
        const testForm = document.createElement('product-form');
        const sessionId = testForm.getSessionId();
        
        // Generate multiple unique IDs to test uniqueness
        const uniqueIds = [];
        for (let i = 0; i < 5; i++) {
          const uniqueId = Date.now().toString() + Math.random().toString(36).substr(2, 9);
          uniqueIds.push(uniqueId);
        }
        
        return {
          sessionId: sessionId,
          uniqueIds: uniqueIds,
          allUnique: uniqueIds.length === new Set(uniqueIds).size,
          sessionIdFromStorage: sessionStorage.getItem('cart_session_id')
        };
      }
    }
  );
}

// Global test function for unique ID generation
window.testProductFormUniqueIds = function() {
  if (!customElements.get('product-form')) {
    return { error: 'ProductForm not defined yet' };
  }
  
  return customElements.get('product-form').testUniqueIdGeneration();
};

// Global test function for product-form ring size reset
window.testProductFormRingSizeReset = function() {
  const productForm = document.querySelector('product-form');
  if (!productForm) {
    return { error: 'ProductForm element not found' };
  }
  
  // Check current ring size selector state
  const ringSizeSelect = document.getElementById('select-ring-size');
  const ringSizeDropdown = ringSizeSelect?.closest('.ring-size-dropdown');
  
  const beforeReset = {
    selectValue: ringSizeSelect?.value || '',
    selectIndex: ringSizeSelect?.selectedIndex || 0,
    buttonText: ringSizeDropdown?.querySelector('.ring-size-button')?.textContent || '',
    isExpanded: ringSizeDropdown?.querySelector('.ring-size-button')?.getAttribute('aria-expanded') === 'true',
    optionsVisible: !ringSizeDropdown?.querySelector('.ring-size-options')?.classList.contains('hidden')
  };
  
  // Test reset function
  productForm.resetRingSizeSelector();
  
  const afterReset = {
    selectValue: ringSizeSelect?.value || '',
    selectIndex: ringSizeSelect?.selectedIndex || 0,
    buttonText: ringSizeDropdown?.querySelector('.ring-size-button')?.textContent || '',
    isExpanded: ringSizeDropdown?.querySelector('.ring-size-button')?.getAttribute('aria-expanded') === 'true',
    optionsVisible: !ringSizeDropdown?.querySelector('.ring-size-options')?.classList.contains('hidden')
  };
  
  return {
    beforeReset: beforeReset,
    afterReset: afterReset,
    resetSuccessful: afterReset.selectValue === '' && 
                    afterReset.selectIndex === 0 && 
                    afterReset.buttonText === 'Select Ring Size' &&
                    !afterReset.isExpanded &&
                    !afterReset.optionsVisible,
    productForm: {
      found: !!productForm,
      hasResetMethod: typeof productForm.resetRingSizeSelector === 'function'
    },
    ringSizeSelect: {
      found: !!ringSizeSelect,
      id: ringSizeSelect?.id || null
    },
    ringSizeDropdown: {
      found: !!ringSizeDropdown,
      hasButton: !!ringSizeDropdown?.querySelector('.ring-size-button'),
      hasCaretIcon: !!ringSizeDropdown?.querySelector('.caret-icon'),
      hasOptions: !!ringSizeDropdown?.querySelector('.ring-size-options')
    }
  };
};
